"use strict";
/**
 * Conditions:
    When incoming payment method is manual payment, IncomingPaymentMethodID should be sent as 'A' in the request. It is set as '' (empty) in SAP.
    When incoming payment method is direct debit, IncomingPaymentMethodID should be sent as 'S' in the request. The same is updated in SAP.
    OutgoingPaymentMethodID can be empty. It is set to 'U' in SAP as default outgoing payment method.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutgoingPaymentMethods = exports.IncomingPaymentMethods = void 0;
var IncomingPaymentMethods;
(function (IncomingPaymentMethods) {
    IncomingPaymentMethods["ManualPayment"] = "A";
    IncomingPaymentMethods["DirectDebit"] = "S";
})(IncomingPaymentMethods || (exports.IncomingPaymentMethods = IncomingPaymentMethods = {}));
var OutgoingPaymentMethods;
(function (OutgoingPaymentMethods) {
    OutgoingPaymentMethods["Empty"] = "";
    OutgoingPaymentMethods["Default"] = "U";
})(OutgoingPaymentMethods || (exports.OutgoingPaymentMethods = OutgoingPaymentMethods = {}));
